import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { EmployeeEffects } from 'app/state/employee/employee.effects';

import { employeeFeature } from './employee.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(employeeFeature), EffectsModule.forFeature([EmployeeEffects])],
})
export class EmployeeStateModule {}
